import React from 'react';
import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes, observer } from 'mobx-react';

import iconFilter from '../../../assets/images/icon-filter.svg';
import styles from './IntraSearchFilter.css';
import { Select } from '../../../common/select';
import { ScreenStore } from '../../../stores/ScreenStore';
import { constants } from '../../../config';

const IPropTypes = {
  className: PropTypes.string,
  selectedFilter: PropTypes.number,
  onFilterChange: PropTypes.func.isRequired,
  filterOptions: MobxPropTypes.arrayOrObservableArray.isRequired,
};

const defaultProps = {
  className: '',
  selectedFilter: null,
};

const IntraSearchFilter = (props) => {
  const getFilterLabel = value => (
    props.filterOptions.find(filter => filter.value === value).label
  );

  const defaultSelectValue = (
    <img src={iconFilter} alt="filter" />
  );

  const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.smallMaxWidth;

  return (
    <div className={[styles.container, props.className].join(' ')}>
      <span className={styles.selectedFilter}>{getFilterLabel(props.selectedFilter)}</span>
      <Select
        onChange={props.onFilterChange}
        className={styles.select}
        options={props.filterOptions.slice()}
        value={defaultSelectValue}
        noIndicator
        rightAligned={mobileVersion}
        selectedClassName={styles.selectedValue}
      />
    </div>
  );
};

IntraSearchFilter.propTypes = IPropTypes;
IntraSearchFilter.defaultProps = defaultProps;

const ObservedIntraSearchFilter = observer(IntraSearchFilter);

export { ObservedIntraSearchFilter as IntraSearchFilter };



// WEBPACK FOOTER //
// ./src/common/home-navbar/intra-search-filter/IntraSearchFilter.jsx